"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Flex_1 = __importDefault(require("./Flex"));
var IconField_1 = __importDefault(require("./IconField"));
var StyledFlex = styled_components_1["default"](Flex_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n"], ["\n  width: 100%;\n  position: relative;\n"])));
var FormField = function (_a) {
    var children = _a.children;
    var childrenArray = react_1["default"].Children.toArray(children);
    // @ts-ignore
    var field = childrenArray.filter(function (child) { return child.type.isField; })[0];
    // @ts-ignore
    var label = childrenArray.filter(function (child) { return child.type.isLabel; })[0];
    // @ts-ignore
    var icon = childrenArray.filter(function (child) { return child.type.isIcon; })[0];
    // @ts-ignore
    var error = childrenArray.filter(function (child) { return child.type.isError; })[0];
    var id = field && (field.props.id || field.props.name);
    var styledLabel = label &&
        react_1["default"].cloneElement(label, {
            htmlFor: id
        });
    return (react_1["default"].createElement(StyledFlex, { column: true },
        styledLabel,
        react_1["default"].createElement(IconField_1["default"], null,
            field,
            icon),
        error));
};
FormField.displayName = 'FormField';
exports["default"] = FormField;
var templateObject_1;
//# sourceMappingURL=FormField.js.map